export default "/lock.png"